// Winterplan Variante B: EINZIGE Stelle für den Stichtag in charliescrew (Code).
// Gelesen von src/lib/timeSlots.ts (Buchung, Kundenbereich, Admin) und
// supabase/functions/_shared/gassi-mail.ts (Kundenmails). Muster wie gassi-kapazitaet.ts.
//
// Stichtag ändern = diese Zeile + die DB-Funktionen (SQL winter-01, drei Stellen
// DATE '...') + charlies-team supabase/functions/_shared/winter-2026.ts.

/** Erster Tag (inklusive, Berliner Kalendertag) des Winterplans. Vergleich als 'YYYY-MM-DD'-String. */
export const WINTER_2026_DATE = "2026-11-09";

/**
 * Obergrenze der NM-Abendschwelle im Gate ab dem Stichtag: gate_kapazitaet_slots rechnet
 * LEAST(capacity_settings.gate_abend_nm, 19:00). Nur für Anzeigetexte (Admin Gate-Einstellungen);
 * winter-2026.test.ts prüft den Gleichlauf mit der Migration 20261110090000.
 */
export const WINTER_2026_ABEND_NM_MAX = "19:00";

/** Berliner Kalendertag als 'YYYY-MM-DD' (en-CA liefert ISO-Reihenfolge). */
export function berlinTagIso(d: Date = new Date()): string {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Berlin", year: "numeric", month: "2-digit", day: "2-digit" }).format(d);
}

/** true, wenn am (Berliner) Tag von `d` der Winterplan gilt. */
export function winterplanAktiv(d: Date = new Date()): boolean {
  return berlinTagIso(d) >= WINTER_2026_DATE;
}
